import { createBrandKit } from '../createBrandKit'
import { ENV } from '@/config'
import logo from '@/assets/brands/evolve-wellness/logo.png'
import favicon from '@/assets/brands/evolve-wellness/favicon.png'

/**
 * Evolve Wellness — logo and colours taken from evolvewellnessmd.com.
 *
 * The mark is white on the site's deep burgundy-black header colour
 * (hsl(0, 63%, 7%)), so that colour is the primary and the same artwork serves
 * every surface. The secondary is a muted tone of the same hue. Name and key
 * come from VITE_APP_NAME / VITE_APP_KEY.
 */
export const evolveWellnessBrand = createBrandKit({
  id: 'evolve-wellness',
  name: ENV.APP_NAME,
  key: ENV.APP_KEY,
  logo,
  favicon,
  colors: {
    primary: { main: '#1D0707' },
    secondary: { main: '#7A5C58' },
  },
})
